var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { CommunicationService } from './../../services/communication.service';
import { EventEmitter, TemplateRef, ChangeDetectorRef, OnInit } from '@angular/core';
import { Listing } from '../../classes/listing';
import { PreferencesService } from '../../services/preferences.service';
import { FormGroup } from '@angular/forms';
import { LeadsService } from '../../services/leads.service';
import { LeadType, LeadTrigger, MapListingToListingInfo } from '../../classes/leads';
import { ListingCategory, ContactFormLocationType } from '../../classes/enums';
import { Angulartics2 } from 'angulartics2';
import { CONTACT_AGENT_PAGE, CONTACT_OFFICE_PAGE, CONTACT_AGENT_RES, CONTACT_AGENT_LUX, CONTACT_AGENT_COMM, ASK_QUESTION_OFFMARKET, ASK_QUESTION_OFFMARKET_AUTH, CONTACT_AGENT_OFFMARKET, CONTACT_AGENT_OFFMARKET_AUTH, ASK_QUESTION_COMM, REQUEST_DETAILS_LUX, ASK_QUESTION_RES, SEND_LISTING_SCHEDULE_VIEWING, SEND_LUX_LISTING_SCHEDULE_VIEWING, SEND_COMM_LISTING_SCHEDULE_VIEWING } from '../../classes/analytics-tags';
import { DomManipulationService } from '../../services/dom-manipulation/dom-manipulation.service';
import { RECAPTCHA_SCRIPT } from '../../classes/dynamicScripts';
import { ErrorService, ErrorKey } from '../../services/error.service';
import { HasSubscriptions } from '../has-subscriptions';
import { CredentialsService } from '../../services/credentials.service';
var ContactAgentComponent = /** @class */ (function (_super) {
    __extends(ContactAgentComponent, _super);
    function ContactAgentComponent(preferencesService, leadsService, communcationService, domManipulationService, credentialsService, errorService, angulartics2, cd) {
        var _this = _super.call(this) || this;
        _this.preferencesService = preferencesService;
        _this.leadsService = leadsService;
        _this.communcationService = communcationService;
        _this.domManipulationService = domManipulationService;
        _this.credentialsService = credentialsService;
        _this.errorService = errorService;
        _this.angulartics2 = angulartics2;
        _this.cd = cd;
        _this.closeButton = new EventEmitter();
        _this.requestSent = new EventEmitter();
        _this.isFixed = true;
        _this.leadInfo = {
            triggerType: LeadTrigger.RequestInfo,
        };
        // has the request sent to the contact agent been completed
        _this.hasFinishedSendingRequest = true;
        _this.show = true;
        _this.ListingCategory = ListingCategory;
        _this.ContactFormLocationType = ContactFormLocationType;
        return _this;
    }
    ContactAgentComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.cd.detectChanges();
        this.addSub(this.credentialsService.isLoggedIn.subscribe(function (isAuthenticated) { return _this.isAuthenticated = isAuthenticated; }));
    };
    ContactAgentComponent.prototype.close = function () {
        this.closeButton.emit();
    };
    ContactAgentComponent.prototype.sendGrecaptcha = function () {
        var _this = this;
        this.addSub(this.domManipulationService.loadScript(RECAPTCHA_SCRIPT).subscribe(function () {
            grecaptcha.execute(_this.recaptchaId);
        }));
    };
    ContactAgentComponent.prototype.getOnSubmit = function () {
        return this.onSubmit.bind(this);
    };
    ContactAgentComponent.prototype.onSubmit = function (recaptchaKey) {
        var _this = this;
        var leadBody = this.constructTheLeadObject();
        this.hasFinishedSendingRequest = false;
        this.leadsService.sendLead(leadBody, recaptchaKey)
            .then(function () {
            if (_this.listing)
                _this.preferencesService.toggleMoreInfoRequested(_this.listing.listingId);
            _this.sendAnalyticsEvent();
            _this.hasFinishedSendingRequest = true;
            _this.closeButton.emit(_this.contactForm.value);
            _this.requestSent.emit();
        })
            .catch(function (err) {
            _this.hasFinishedSendingRequest = true;
            _this.errorService.displayError(ErrorKey.lead, err.error.errorCode, 30);
        });
    };
    ContactAgentComponent.prototype.constructTheLeadObject = function () {
        var leadBody = {
            leadType: this.leadInfo.leadType ? this.leadInfo.leadType :
                this.listing.isOffMarket ? LeadType.HVEOffMarket : LeadType.Listing,
            triggerType: this.leadInfo.triggerType,
            agentInfo: this.leadInfo.agentInfo,
            listingInfo: this.listing && !this.listing.isOffMarket ? MapListingToListingInfo(this.listing) : null,
            officeInfo: this.leadInfo.officeInfo,
            contactInfo: {
                name: this.name.value,
                email: this.email.value,
                homePhone: this.phone.value,
                latitude: this.listing ? this.listing.lat : -1,
                longitude: this.listing ? this.listing.lng : -1,
                postalCode: this.listing && this.listing.postalCode ? this.listing.postalCode : '',
                city: this.listing && this.listing.city ? this.listing.city.toLowerCase() : '',
                province: this.listing && this.listing.province ? this.listing.province : ''
            },
            contactPref: {
                email: !this.contactByPhone.value,
                telephone: !!this.contactByPhone.value
            },
            comments: this.comments.value
        };
        if (this.locationType === ContactFormLocationType.LISTING_SCHEDULE_VIEWING) {
            leadBody.weeklyAvailability = {
                weekend: {
                    morning: this.weekendMorning.value,
                    afternoon: this.weekendAfternoon.value,
                    evening: this.weekendEvening.value,
                },
                weekday: {
                    morning: this.weekdayMorning.value,
                    afternoon: this.weekdayAfternoon.value,
                    evening: this.weekdayEvening.value,
                }
            };
        }
        return leadBody;
    };
    ContactAgentComponent.prototype.sendAnalyticsEvent = function () {
        var tagName = null;
        switch (this.locationType) {
            case ContactFormLocationType.AGENT_PAGE_CONTACT:
                tagName = CONTACT_AGENT_PAGE;
                break;
            case ContactFormLocationType.OFFICE_PAGE_CONTACT:
                tagName = CONTACT_OFFICE_PAGE;
                break;
            case ContactFormLocationType.LISTING_ASK_QUESTION:
                switch (this.communcationService.listings.currentShownListingType.value) {
                    case ListingCategory.COMMERCIAL:
                        tagName = ASK_QUESTION_COMM;
                        break;
                    case ListingCategory.LUXURY:
                        tagName = REQUEST_DETAILS_LUX;
                        break;
                    case ListingCategory.RESIDENTIAL:
                        tagName = ASK_QUESTION_RES;
                        break;
                }
                break;
            case ContactFormLocationType.LISTING_ASK_QUESTION_OFFMARKET:
                tagName = this.isAuthenticated ? ASK_QUESTION_OFFMARKET_AUTH : ASK_QUESTION_OFFMARKET;
                break;
            case ContactFormLocationType.LISTING_OFFMARKET_CONTACT_AGENT:
                tagName = this.isAuthenticated ? CONTACT_AGENT_OFFMARKET_AUTH : CONTACT_AGENT_OFFMARKET;
                break;
            case ContactFormLocationType.LISTING_CONTACT_AGENT:
                switch (this.communcationService.listings.currentShownListingType.value) {
                    case ListingCategory.COMMERCIAL:
                        tagName = CONTACT_AGENT_COMM;
                        break;
                    case ListingCategory.LUXURY:
                        tagName = CONTACT_AGENT_LUX;
                        break;
                    case ListingCategory.RESIDENTIAL:
                        tagName = CONTACT_AGENT_RES;
                        break;
                }
                break;
            case ContactFormLocationType.LISTING_SCHEDULE_VIEWING:
                switch (this.communcationService.listings.currentShownListingType.value) {
                    case ListingCategory.COMMERCIAL:
                        tagName = SEND_COMM_LISTING_SCHEDULE_VIEWING;
                        break;
                    case ListingCategory.LUXURY:
                        tagName = SEND_LUX_LISTING_SCHEDULE_VIEWING;
                        break;
                    case ListingCategory.RESIDENTIAL:
                        tagName = SEND_LISTING_SCHEDULE_VIEWING;
                        break;
                }
                break;
        }
        this.angulartics2.eventTrack.next({
            properties: {
                event: tagName
            }
        });
    };
    Object.defineProperty(ContactAgentComponent.prototype, "name", {
        get: function () { return this.contactForm.controls['name']; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ContactAgentComponent.prototype, "email", {
        get: function () { return this.contactForm.controls['email']; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ContactAgentComponent.prototype, "phone", {
        get: function () { return this.contactForm.controls['phone']; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ContactAgentComponent.prototype, "contactByPhone", {
        get: function () { return this.contactForm.controls['contactByPhone']; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ContactAgentComponent.prototype, "contactType", {
        get: function () { return this.contactForm.controls['contactType']; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ContactAgentComponent.prototype, "buy", {
        get: function () { return this.contactForm.controls['buy']; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ContactAgentComponent.prototype, "sell", {
        get: function () { return this.contactForm.controls['sell']; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ContactAgentComponent.prototype, "comments", {
        get: function () { return this.contactForm.controls['comments']; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ContactAgentComponent.prototype, "weekdayMorning", {
        get: function () { return this.contactForm.controls['weekdayMorning']; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ContactAgentComponent.prototype, "weekdayAfternoon", {
        get: function () { return this.contactForm.controls['weekdayAfternoon']; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ContactAgentComponent.prototype, "weekdayEvening", {
        get: function () { return this.contactForm.controls['weekdayEvening']; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ContactAgentComponent.prototype, "weekendMorning", {
        get: function () { return this.contactForm.controls['weekendMorning']; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ContactAgentComponent.prototype, "weekendAfternoon", {
        get: function () { return this.contactForm.controls['weekendAfternoon']; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ContactAgentComponent.prototype, "weekendEvening", {
        get: function () { return this.contactForm.controls['weekendEvening']; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ContactAgentComponent.prototype, "requestMoreInfo", {
        get: function () { return this.contactForm.controls['requestMoreInfo']; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ContactAgentComponent.prototype, "findSimilarHomes", {
        get: function () { return this.contactForm.controls['findSimilarHomes']; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ContactAgentComponent.prototype, "sellAProperty", {
        get: function () { return this.contactForm.controls['sellAProperty']; },
        enumerable: true,
        configurable: true
    });
    ContactAgentComponent.prototype.isFormControlValid = function (control) {
        return !(control.invalid && (control.dirty || control.touched));
    };
    ContactAgentComponent.prototype.isFormControlEmpty = function (control) {
        return !control.value || control.value.length === 0;
    };
    ContactAgentComponent.prototype.getModifyInputIcon = function (control) {
        return this.isFormControlValid(control) ? 'close'
            : (this.isFormControlEmpty(control) ? '' : 'highlight_off');
    };
    return ContactAgentComponent;
}(HasSubscriptions));
export { ContactAgentComponent };
